import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        name: 'painel',
        path: '/portal/painel',
        component: () => import('@/views/portal/painel.vue')
    },

    {
        name: 'notasfiscais',
        path: '/integrador/notasfiscais',
        component: () => import('@/views/integrador/notasfiscais.vue')
    },

    {
        name: 'atendimento',
        path: '/portal/atendimentos/:id',
        component: () => import('@/views/suporte/atendimento.vue')
    },
    {
        name: 'tarefa',
        path: '/portal/tarefas/:id',
        component: () => import('@/views/suporte/tarefa.vue')
    },

    {
        name: 'atendimentos',
        path: '/portal/atendimentos',
        component: () => import('@/views/suporte/atendimentos.vue')
    },
    {
        name: 'tarefas',
        path: '/portal/tarefas/:projetoId?',
        component: () => import('@/views/suporte/tarefas.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkActiveClass: 'is-active',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

export default router
